import { BeckyModel } from '@wix/thunderbolt-becky-root'
import { DataMapName } from '@wix/thunderbolt-becky-types'
import { CatharsisArgs } from '../types/catharsis.types'
import { getCatharsis } from './catharsis'

export const singleTransaction = (
	beckyModel: BeckyModel,
	catharsisArgs: CatharsisArgs,
	usedDataMaps: Iterable<DataMapName>
) => {
	const { structure, data, translations, ...environment } = beckyModel

	const catharsis = getCatharsis(catharsisArgs)

	catharsis.transaction(({ updateStructure, updateData, updateEnvironment, updateTranslation }) => {
		updateEnvironment(environment)

		for (const compId in structure) {
			updateStructure(compId, structure[compId])
		}

		for (const dataMapName of usedDataMaps) {
			for (const id in data[dataMapName]) {
				const dataItem = data[dataMapName][id]
				updateData(dataMapName, id, dataItem)
			}
		}

		// Update the model with the translations of the active language
		const { language, originalLanguage } = environment
		if (language && language !== originalLanguage && translations?.[language]) {
			const translatedDataItems = translations[language].data.document_data
			for (const documentDataItemId in translatedDataItems) {
				updateTranslation(language, documentDataItemId, translatedDataItems[documentDataItemId])
			}
		}
	})
}
